import { HStack, Text, useColorModeValue } from "@chakra-ui/react";
import HeartIcon from "../../assets/icons/HeartIcon";
import ColorModeButton from "./ColorModeButton";
import KellyanButton from "./KellyanButton";
import GarrettButton from "./GarrettButton";

export default function Footer() {
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");
  const year = new Date().getFullYear();

  return (
    <HStack
      w="100%"
      h="50px"
      justifyContent="space-between"
      alignItems="center"
      px="30px"
      borderColor={useColorModeValue("gray.200", "gray.700")}
      flexShrink={0} // Prevent the footer from shrinking
    >
      <HStack spacing="12px">
        <ColorModeButton />
      </HStack>
      <HStack spacing="12px">
        <GarrettButton />
        <HeartIcon />
        <KellyanButton />
        <Text color={textColor} fontFamily="Lilita One" fontSize="xl">
          {year}
        </Text>
      </HStack>
    </HStack>
  );
}
